import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import CreateCoverPhotoModal from '../../Modals/CreateCoverPhotoModal/CreateCoverPhotoModal'
import { ICrop } from '../../../infrastructure/interfaces'
import {createCrop, deleteCrop} from '../../../actions/actions'
import HeaderBar from '../../HeaderBar/HeaderBar';
import DeleteConfirmModal from '../../Modals/DeleteConfirmModal';
import { contentImagesRelativePath } from '../../../constants';

export interface IManageCropCoverImagesProps {
  crops?: ICrop[];
  createCrop(photoName: string, formData: FormData): void;
  deleteCrop(crop: ICrop): void;
}

export interface IManageCropCoverImagesState {
    showEditModal: boolean;
    showDeleteCropModal: boolean;
    selectedCrop?: ICrop;
}

const mapStateToProps = (state: any) => {
  return {
    crops: state.wizard.crops,
  };
};

const mapDispatchToProps = (dispatch: any): any => {
  return {
    createCrop: (photoName: string, formData: FormData) => {
      dispatch(createCrop(photoName, formData));
    },
    deleteCrop: (crop: ICrop) => {
      dispatch(deleteCrop(crop));
    },
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ManageCropCoverImagesTable extends React.Component<IManageCropCoverImagesProps, IManageCropCoverImagesState> {
  tableRow: HTMLElement;
  constructor(props: IManageCropCoverImagesProps) {
    super(props);
    this.state = {
      showEditModal: false,
      showDeleteCropModal: false,
    };
  }

  ondeleteCropRequest(crop: ICrop) {

    if(crop.id) {
      this.setState({
          showEditModal: false,
          showDeleteCropModal: true,
          selectedCrop: crop,
      });
    }
  }

  oncreateCrop() {

    this.setState({
        showEditModal: true,
        showDeleteCropModal: false,
        selectedCrop: undefined,
    });
  }

  deleteCrop(crop: ICrop) {
    this.props.deleteCrop(crop);
  }

  closeModals() {

    this.setState({
      showEditModal: false,
      showDeleteCropModal: false,
      selectedCrop: undefined,
    });
  }

  render() {

    const {
      crops,
    } = this.props;
    var nonNullCropCoverImages = crops ? crops : [];

    return (
      <div className="root-container">
        <HeaderBar />
        <div className="inner-su-container">
          <div className="manage-items-row-offsetRight">

            <div className="in-row-text-container">
              Manage Cover Icons
            </div>

            <div className="in-row-button-container">
            
              <button
                className="btn primary-green large"
                onClick={() => {this.oncreateCrop();}}
                title={TooltipCont.CREATE_COVER_PHOTO}
              >
                Create New Cover Image
              </button>
          </div>
          </div>
          <table className="table-scrollableSU documents-table">
            <thead style={{ paddingRight: getScrollbarWidth() }}>
              <tr>
                <th>Image</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="document-table-body">
              {nonNullCropCoverImages.map((c: ICrop) =>
                <tr key={c.id} ref={tr => this.tableRow = tr!}>
                  <td>
                    <img className="inlineImagesTableImage" src={contentImagesRelativePath + c.defaultImage} />
                  </td>
                  <td>
                    <div className="button-wrapper">
                      <button
                        className="btn primary-red"
                        onClick={() => this.ondeleteCropRequest(c)}
                        title={TooltipCont.DELETE}
                        disabled={false}
                      >
                        Delete
                      </button>
                      
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>

          <CreateCoverPhotoModal
              show={this.state.showEditModal}
              onClose={() => this.closeModals()}
              createCrop={(cropName: string, formData: FormData) => {
                    this.props.createCrop(cropName, formData)
                    this.closeModals();
                    }
                }
          />

          <DeleteConfirmModal
              show={this.state.showDeleteCropModal}
              onClose={() => this.closeModals()}
              onSave={() => {
                  if(this.state.selectedCrop && this.state.selectedCrop.id) {
                    this.deleteCrop(this.state.selectedCrop);
                  }
                  this.closeModals();
              }}
              title={(this.state.selectedCrop)
                ? 'Delete Icon "' + this.state.selectedCrop.name + '"?'
                : 'Error. Please go back.'}
          />
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageCropCoverImages.tsx